<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="carPreferredVendorObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger when the rental company is not a preferred vendor </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="carPreferredVendorObj.isActive"
                        v-model="carPreferredVendorObj.isActive" @input="carPreferredVendor" :left-label="true">{{
                            carPreferredVendorObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <StandardRuleActions v-if="carPreferredVendorObj.isActive" :ruleObj="carPreferredVendorObj" :title="title" @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        StandardRuleActions
    },
    data() {
        return {
            carPreferredVendorObj: this.value ? this.value : {
                name: "carPreferredVendor",
                isActive: false,
                type: 'car',
                message: 'Trigger when the rental company is not a preferred vendor',
            },
            title: "Rental company is not a preferred vendor"
        }
    },
    methods: {
        carPreferredVendor() {
            if (!this.carPreferredVendorObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.carPreferredVendorObj.useCustomActions = false;
            delete this.carPreferredVendorObj.visibility;
            delete this.carPreferredVendorObj.approvalLevel;
            delete this.carPreferredVendorObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into carPreferredVendorObj
            this.carPreferredVendorObj = { ...this.carPreferredVendorObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams()
            }

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit('carPreferredVendor', this.carPreferredVendorObj)
        },
    },
    mounted() {
        this.carPreferredVendorObj.type = 'car';
        this.emitRuleObj();

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.carPreferredVendorObj = this.value;
                this.carPreferredVendorObj.type = 'car';
                this.emitRuleObj();
            },
            deep: true,
        },
    },
}
</script>